<ng-container *ngIf="loading() || premiumActivities?.productCode">
  <lx-card-container
    skeletonHeight="22rem"
    [loading]="loading()"
    data-qa="premiumActivities_cardContainer"
    i18n-title
    title="Premium Activities"
    type="premium-activities"
  >
    <div class="premium-activities">
      <div class="extra-card">
        <lx-image class="extra-card__image" alt="Premium Activities" [image]="PREMIUM_ACTIVITIES_FALLBACK_IMAGE" [width]="480" [height]="320" />
        <div class="extra-card__content">
          <div class="extra-card__content__text" i18n>Three afternoons a week, step up your summer camp experience!</div>
          <div class="extra-card__content__text" i18n>
            Our <span class="extra-card__content__text--strong">Premium Activities</span> give you access to exclusive excursions, exciting sports, and more...
          </div>
          <lx-button (buttonClick)="onLearnMoreClick()" [buttonStyle]="'link'" data-qa="premiumActivities_learnMore" i18n-text text="Learn more"></lx-button>
        </div>
      </div>
      <lx-option-card
        class="premium-activities__checkbox"
        title="Add to my stay"
        i18n-title
        [withImage]="false"
        [type]="'checkbox'"
        [selectedOption]="selected"
        (selectedOptionChanged)="updateSelection()"
        [attr.data-qa]="'premiumActivities_addToMyStay'"
      ></lx-option-card>
    </div>
  </lx-card-container>
</ng-container>
<lx-side-panel-gallery
  [visible]="premiumActivitiesDialogVisible"
  (hiddenPanel)="hidePremiumActivitiesDialog()"
  [fallbackImage]="PREMIUM_ACTIVITIES_FALLBACK_IMAGE"
  data-qa="premium_activities_sidePanel"
  [images]="images"
>
  <h4 class="premium-activities__details__title" i18n>Premium activities in {{ (schoolLocation$ | async)?.schoolName }}</h4>
  <div class="premium-activities__details__content" *ngFor="let extraInfo of premiumActivities?.extrasInfo">
    <h5 class="premium-activities__details__content__title">{{ extraInfo?.name }}</h5>
    <p class="premium-activities__details__content__description">{{ extraInfo?.description }}</p>
  </div>
</lx-side-panel-gallery>
